import { render, staticRenderFns } from "./slot.vue?vue&type=template&id=3a679a8a&scoped=true&lang=pug&"
import script from "./slot.vue?vue&type=script&lang=js&"
export * from "./slot.vue?vue&type=script&lang=js&"
import style0 from "./slot.vue?vue&type=style&index=0&id=3a679a8a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a679a8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3a679a8a', component.options)
    } else {
      api.reload('3a679a8a', component.options)
    }
    module.hot.accept("./slot.vue?vue&type=template&id=3a679a8a&scoped=true&lang=pug&", function () {
      api.rerender('3a679a8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layertree/component/label/slot.vue"
export default component.exports